
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { Validators } from '@angular/forms';
import { SettingsService } from 'src/app/settings/settings.service';;
import { ConcentracionFactoring } from '../concentracion-factoring/concentracion.factoring';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DicomComponent } from '../dicom/dicom.component';
declare var $: any;

@Component({
    selector: 'app-dashboard-compras',
    templateUrl: './dashboard-compras.html',
    styleUrls: ['./dashboard-compras.less'],
    standalone: false
})
export class DashboardCompras implements OnInit, OnDestroy {


  @ViewChild(ConcentracionFactoring) dash_compras! : ConcentracionFactoring;

  formFechas: FormGroup;

  constructor(public snackBar: MatSnackBar, private fb: FormBuilder, 
    private router: Router, public dialog: MatDialog,  
    public settings: SettingsService) { 

      
      this.formFechas = this.fb.group({
        fechaI: ['', Validators.required],
        fechaF: ['', Validators.required]
      });


    }

    dash_update(){
      this.dash_compras.dash_update();
    }

  myObserver:any;
  ngOnDestroy() {
    this.myObserver.unsubscribe();
  }

  @HostListener('window:companyIdChanged', ['$event'])
  onCompanyIdChanged(event: CustomEvent) {
    console.log('Company ID changed:', event.detail);
    this.id_company = localStorage.getItem('company_id');
    this.ngOnInit(); 
  }


  ngOnInit() {

    this.myObserver = this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        console.log("router company_id-->" + localStorage.getItem('company_id'))
        this.load_all();
      }
     });
     this.load_all()


  }

  company_id:any;
  id_company:any;
  load_all()
  {
    this.id_company = localStorage.getItem('company_id')
    this.company_id = this.id_company;

    let date = new Date()
    let yy = date.getFullYear();
    let mm = date.getMonth()+1;
    let dd = date.getDate();
    this.date_end = yy+'-'+mm+'-'+dd;

    let date2 = new Date();
    date2.setMonth(date2.getMonth() - 5)
    let yy2 = date2.getFullYear();
    let mm2 = date2.getMonth()+1;
    let dd2 = date2.getDate();
    this.date_start = yy2+'-'+mm2+'-'+dd2;


    this.formFechas.controls['fechaI'].setValue(date2)
    this.formFechas.controls['fechaF'].setValue(date)

    this.get_credenciales();
    
  }

  date_start:any;
  fecha_desde($e:any){
    let date = new Date($e.value);
    let yy = date.getFullYear();
    let mm = date.getMonth()+1;
    let dd = date.getDate();
    this.date_start = yy+'-'+mm+'-'+dd;
    this.formFechas.controls['fechaI'].setValue(date)

    this.dash_compras.update_dashboard()
  }

  date_end:any;
  fecha_hasta($e:any){
    let date = new Date($e.value);
    let yy = date.getFullYear();
    let mm = date.getMonth()+1;
    let dd = date.getDate();
    this.date_end = yy+'-'+mm+'-'+dd;
    this.formFechas.controls['fechaF'].setValue(date)

    this.dash_compras.update_dashboard()
  }

  d_btn:boolean=false;
  clear(){

    this.d_btn = true;

    let date = new Date()
    let yy = date.getFullYear();
    let mm = date.getMonth()+1;
    let dd = date.getDate();
    this.date_end = yy+'-'+mm+'-'+dd;

    let date2 = new Date();
    date2.setMonth(date2.getMonth() - 5)
    let yy2 = date2.getFullYear();
    let mm2 = date2.getMonth()+1;
    let dd2 = date2.getDate();
    this.date_start = yy2+'-'+mm2+'-'+dd2;


    this.formFechas.controls['fechaI'].setValue(date2)
    this.formFechas.controls['fechaF'].setValue(date)

    this.dash_compras.update_dashboard()


    setTimeout(()=>{         
      this.d_btn = false;
    }, 6000);

  }


  dicom(){
    const dialogRef = this.dialog.open(DicomComponent,{
      width: '900px',
      autoFocus:false,
    });
    
    dialogRef.afterClosed().subscribe((result:any) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  async get_credenciales() {
    try {
      const bd: any = await this.settings.get_query(1, '/cliente/obtener-credenciales-sii//' + this.id_company + '/');
      var body_data: any =bd._body;
      switch (bd.status) {
        case 201:
        case 200:

        console.log("ACA", body_data.code)

                if(body_data.code == null || body_data.code == "" || body_data.code == undefined){
                  $("#disable_compras").addClass("disable_btn_llamativo");
                }else{
                  $("#disable_compras").removeClass("disable_btn_llamativo");
                }


          break;
        default:

          break;
      }
    } catch (bd: any) {

    }
  }


}